<template>
  <v-row>
    <v-col cols="12">
      <latest-updates :updates="this.activities" :loading="loading" />
    </v-col>

    <v-col cols="12">
      <project-task-lists :project="project" />
    </v-col>
  </v-row>
</template>

<script>
import LatestUpdates from '@/components/common/LatestUpdates'
import ProjectTaskLists from '@/components/tasks/project/ProjectTaskLists'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProjectOverview',
  components: {
    LatestUpdates,
    ProjectTaskLists
  },

  computed: {
    ...mapGetters('projects', ['project']),
    ...mapGetters('activityLogs', ['activities', 'loading'])
  },
  methods: {
    ...mapActions('activityLogs', ['fetchProjectActivityLogs'])
  },
  watch: {
    project: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchProjectActivityLogs(this.project.id)
      }
    }
  }
}
</script>
